export const endpoints = {
  health: "/api/v1/health/",
  branding: "/api/v1/platform/branding/",
  login: "/token/access/",
  refresh: "/token/refresh/",
  verify: "/token/verify/",
  logout: "/api/v1/logout/",
  profile: "/api/v1/profile/",
  directoryContactGroups: "/api/v1/directory-contact-groups/",
  directoryContacts: "/api/v1/directory-contacts/",
  voipDeviceTokens: "/api/voip/device-tokens/",
  notesList: "/api/cm/notes/",
  notesCreate: "/api/cm/notes/create/",
  callLogs: "/api/cm/call-logs/",
  chatConversations: "/api/cm/chat/conversations/",
  chatUsers: "/api/cm/chat/users/",
  /** phonesetup (Quick Access / cover banner) */
  phoneQuickDial: "/api/phone/qucikdial/",
  phoneCoverImage: "/api/phone/coverimage/",
  phoneIconTypes: "/api/icontype/",
} as const;
